import { Table } from "antd";
import { useQuery } from "react-query";
import DashboardMaster from "../dashboard/dashboard-master-layout.component";
import React, { ReactElement } from "react";
import { getSubscriberList } from "./subscriber.thunks";
import { tableColumns } from "../../lib/helpers.table";
import { ArticleInterface } from "../articles/article.interface";
import { Link } from "react-router-dom";

const SubscriberList = (): ReactElement => {
  const moduleName = "subscribers"; // we will use this as both the query name and the delete API endpoint
  const [page, setCurrentPage] = React.useState(0);

  const { data } = useQuery(
    [moduleName, { page }],
    () => getSubscriberList({ page }),
    { keepPreviousData: true }
  );

  const tableData = data ? data.docs : [];

  const pagination = {
    current: data?.page,
    pageSize: data?.limit,
    hideOnSinglePage: true,
    showSizeChanger: false,
    total: data?.totalDocs,
    onChange: (page) => {
      pagination.current = page; // updates table pagination
      setCurrentPage(page); // re-fetch the api
    },
  };

  const columnData = [
    {
      title: "Email",
      dataIndex: "email",
      render: (text, doc) => (
        <Link to={`${moduleName}/` + doc._id}>{doc?.email}</Link>
      ),
    },
  ];

  const columns = tableColumns(
    columnData,
    { field: "Name", url: `${moduleName}/` },
    { url: moduleName }
  );
  return (
    <>
      <DashboardMaster
        showAdd={true}
        title="Subscribers"
        addUrl={`/dashboard/${moduleName}/new`}
        showExport={true}
        exportFileName={"subscribers"}
        exportLink={"/subscribers/download/file"}
      >
        <Table
          rowKey={(doc: ArticleInterface) => doc._id}
          columns={columns}
          dataSource={tableData}
          pagination={pagination}
        />
      </DashboardMaster>
    </>
  );
};

export default SubscriberList;
